<template>
  <el-container class="is-vertical" style="flex-shrink: 0">
    <el-main class="login-register">
      <div class="d-flex justify-center">
        <img src="/static/coobo_logo.png" alt="" class="login-logo">
      </div>
      <div class="headings">
        <h2>Welcome back!</h2>
        <h3>Let's get you signed in</h3>
      </div>

      <div class="form-cnt">
        <el-form ref="loginForm" :model="login" :rules="rules">
          <div class="socials">
            <h4>Login</h4>
            <p>
              Welcome, please login with your Embibe account.
            </p>
            <a :href="$store.state.API_URL + 'connect/google'" class="auth-button google-plus">
              <span class="icon"><span class="circle"><img src="/static/google.svg" alt=""></span>
                </span>
              <span class="text">Log in with <b>Google</b></span>
            </a>
          </div>
          <div class="dev-login">  <!-- v-if="$store.state.env === 'development'" -->
            <el-row el-row type="flex" :gutter="20" >
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <label>
                  <span>Email</span>
                  <el-form-item prop="email">
                    <el-input
                            @keyup.native="showError = false"
                            @keyup.enter.native="submitForm('loginForm')"
                            type="email"
                            placeholder="Enter your email"
                            v-model="login.email">
                    </el-input>
                  </el-form-item>
                </label>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <label>
                  <span>Password</span>
                  <el-form-item prop="password">
                    <el-input
                            @keyup.native="showError = false"
                            @keyup.enter.native="submitForm('loginForm')"
                            type="password"
                            placeholder="Enter your password"
                            v-model="login.password">
                    </el-input>
                  </el-form-item>
                </label>
              </el-col>
            </el-row>
            <div class="error-message" style="pointer-events: none; transition: opacity .2s; color: red; text-align: center;" :style="{opacity: showError ? '1' : '0'}">
              Wrong username or password
            </div>
            <div class="actions flex-center">
              <el-button type="success" @click="submitForm('loginForm')">Sign in</el-button>
            </div>
          </div>
        </el-form>
      </div>

    </el-main>
  </el-container>
</template>

<script>
  export default {
    name: 'Login',
    data () {
      return {
        login: {
          email: "",
          password: "",
        },
        showError: false,
        rules: {
          email: [
            {required: true, message: 'Please input email address', trigger: 'blur'},
            {type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change']},
          ],
          password: [
            {required: true, message: 'Password should not be blank', trigger: ['blur', 'change']},
          ]

        }
      }
    },
    mounted() {
      if (this.$route.query.redirect) {
        localStorage.setItem("loginRedirect", this.$route.query.redirect);
      }
    },
    methods: {
      submitForm(formName) {
        console.log(localStorage.getItem("loginRedirect"));
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.showError = false;
            this.$store.dispatch('authRequest', {
              identifier: this.login.email.toLowerCase(),
              password: this.login.password,
              method: 'POST',
              url: this.$store.state.API_URL+'auth/local'
            }).then((resp) => {
              this.$store.commit("setState", {loggedIn: true});
    
              let tokenWin = document.getElementById('token-iframe').contentWindow;
              tokenWin.postMessage({
                  jwt: resp.data.jwt,
              }, '*');
              let redirect = localStorage.getItem("loginRedirect");
              console.log('WTF', redirect);
              if (redirect !== null) {
                localStorage.removeItem("loginRedirect");
                window.location.href = redirect;
              } else {
                this.$router.push(redirect ? redirect : '/my-library')
                window.location.href = redirect ? redirect : '/my-library'
              }
            }).catch(()=> {
              console.log('error catch!!');
              if(localStorage.getItem("jwt")) {
                window.location.href ='/my-library'
              }
              this.showError = true;
            })
            // this.axios.post(this.$store.state.API_URL+'auth/local', {
            //     identifier: this.login.email,
            //     password: this.login.password
            //   }).then((response) => {
            //     this.$store.state.user = response.data.user;
            //     this.$store.state.jwt = response.data.jwt;
            //     localStorage.setItem('jwt', response.data.jwt);

            //     this.$store.commit("setState", {loggedIn: true});
            //     this.$router.push('/my-library');
            //   });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },

    },
    components: {}
  }
</script>



// WEBPACK FOOTER //
// src/pages/Login.vue